<template>
  <!-- Conekta Card -->
  <div id="conekta-method">
    <div v-show="is_card">
      <div class="py-2">
        <p class="mb-0">
          Realiza tu pago con cargo a tu tarjeta de crédito/d&eacute;bito. Tu
          orden llegará de 10 a 20 días.
        </p>
        <h5 class="h5 mb-3 mt-3 text-black" v-show="is_card">
          Datos de tarjeta
        </h5>
        <div id="card-container" class="p-2 border">
          <div id="card-form" v-show="is_card">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                data-conekta="card[name]"
                placeholder="Nombre de cuentahabiente"
              />
            </div>
            <div class="form-group"></div>
            <div class="form-group row">
              <div class="col-md-9">
                <input
                  type="text"
                  class="form-control"
                  data-conekta="card[number]"
                  placeholder="Número de tarjeta"
                />
              </div>
              <div class="col-md-3">
                <input
                  type="text"
                  class="form-control"
                  data-conekta="card[cvc]"
                  placeholder="CVC"
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-6">
                <select
                  id="exp_month"
                  class="form-control"
                  data-conekta="card[exp_month]"
                >
                  <option value="0">.: Selecciona el mes :.</option>
                  <option
                    v-for="(month, index) in card_months"
                    :key="index"
                    :value="month"
                  >
                    {{ month }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <select
                  id="exp_year"
                  class="form-control"
                  data-conekta="card[exp_year]"
                >
                  <option value="0">.: Selecciona el año :.</option>
                  <option
                    v-for="(year, index) in card_years"
                    :key="index"
                    :value="year"
                  >
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group" v-if="total >= 1000">
              <small class="text-left d-block" style="color: red"
                >Pago a meses solo a partir de $1000
              </small>
              <select
                name="months_to_pay"
                id="months_to_pay"
                v-model="months"
                class="form-control"
              >
                <option value="0">.: Pago a meses :.</option>
                <option value="3">3 meses</option>
                <option value="6">6 meses</option>
                <option value="9">9 meses</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group pt-2">
        <loading :active.sync="is_loading"></loading>
        <button
          @click="placeOrder"
          :disabled="desactivar"
          class="btn btn-success btn-lg py-3 btn-block"
        >
          Procede al pago
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "Conekta",
  props: [
    "is_card",
    "card_months",
    "card_years",
    "total",
    "receiver",
    "userData",
    "products",
    "address",
  ],
  components: {
    Loading,
  },
  data() {
    return {
      months: 0,
      desactivar: false,
      is_loading: false,
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      conekta_token: "",
      codeCoupon:"",
    };
  },
  created(){
    const script = document.createElement("script");
    script.src = "https://cdn.conekta.io/js/latest/conekta.js";
    script.async = true;
    document.body.appendChild(script);
  },
  methods: {
    placeOrder: function () {
      this.desactivar = true;
      this.is_loading = true;
      this.fillReceiverName();
      this.fillMonths();
      this.validateAddressAndSendToConekta();
    },
    fillReceiverName: function () {
      if (this.receiver.name.length === 0 || this.receiver.name === "") {
        this.receiver.name =
          this.userData.name +
          " " +
          this.userData.lastname;
      }
    },
    fillMonths: function () {
      if (this.months == 0) {
        this.months = 1;
      }
    },
    validateAddressAndSendToConekta: function () {
      if (jQuery.isEmptyObject(this.address)) {
        this.desactivar = false;
        this.$snotify.warning(
          "Falta la dirección de envío. Selecciona o registra una dirección de envío"
        );
        this.is_loading = false;
      } else {
        this.sendDataConekta();
      }
    },
    // Funcion para realizar el cobro por tarjeta de credito o debito
    sendDataConekta: function () {
      Conekta.setPublicKey(process.env.VUE_APP_CONEKTA_PUB_KEY);
      Conekta.setLanguage("es");
      var form = $("#card-form");
      Conekta.Token.create(form, this.successConekta, this.errorConekta);
    },
    successConekta: function (response) {
      console.log("suc", $cookies.get("uidmmkg") );
      console.log("suc", $cookies.get("utoken") );
      this.conekta_token = response.id;
      if (this.months == "") {
        this.months = 0;
      }
      axios({
        method: "POST",
        url: this.api_url + "/payment/card",
        data: {
          user_id: $cookies.get("uidmmkg"),
          token: this.conekta_token,
          months: this.months,
          items: this.products,
          address: this.address,
          receiver: this.receiver,
          code: this.codeCoupon,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.desactivar = false;
          this.is_loading = false;
          console.info("Respuesta de pago");
          console.info(response.data.response);
          if (response.data.response.status) {
            this.addToTagManager(
              this.products,
              this.months,
              this.address,
              "El metodo de pago es por tarjetas de credito y debito conekta",
              new Date().toLocaleString("en-US")
            );
            this.$store.commit('saveSeveralProducts', this.products);
            this.$router.push({
              name: "thanks",
              query: { orden: response.data.paymentData.order },
            });
          } else {
            this.$snotify.warning(response.data.response.message);
          }
          this.is_loading = false;
        })
        .catch((error) => {
          this.is_loading = false;
          this.desactivar = false;
          this.$snotify.error(error);
        });
    },
    errorConekta: function (response) {
      console.error(response);
      this.$snotify.error(response.message_to_purchaser);
      this.is_loading = false;
      this.desactivar = false;
    },
    addToTagManager: function (
      products,
      months,
      address,
      paymentMethod,
      datePayment
    ) {
      window.dataLayer.push({
        event: "Pago",
        pageURL: this.$router.currentRoute.fullPath,
        product: products,
        months: months,
        address: address,
        paymentMethod: paymentMethod,
        datePayment: datePayment,
      });
    },
  },
};
</script>

<style>
</style>